import { dumpErrorSerializer, dumpResultSerializer } from "@megaron/db-dump/contract";
import { HttpAction } from "@megaron/http-service";
import { Serializers } from "@megaron/serializers";

const generateDump = HttpAction({
  path: "/dumps/generate",
  method: "post",
  requiresAuth: true,
  bodySerializer: Serializers.object({}),
  valueSerializer: dumpResultSerializer,
  errorSerializer: dumpErrorSerializer,
});

export const dumpActions = {
  generateDump,
};
